module.exports = __webpack_public_path__ + "static/img/walking-man-grey.f119506.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/walking-man-grey.svg
// module id = UwM/
// module chunks = 74